import { Icon } from "../components/common/Icon";
import { SmartLink } from "../components/common/SmartLink";
import { useDocumentMeta } from "../lib/useDocumentMeta";

const valueCards = [
  {
    icon: "brain" as const,
    title: "Intellectual Rigor",
    copy: "Deep thinking and precision in approach"
  },
  {
    icon: "chevrons" as const,
    title: "Architectural Discipline",
    copy: "Building systems that stand the test of time"
  },
  {
    icon: "shield" as const,
    title: "Accountability for Correctness",
    copy: "Taking ownership of authoritative decisions"
  },
  {
    icon: "clock" as const,
    title: "Long-term Thinking",
    copy: "Building infrastructure for the future"
  }
];

const jobCards = [
  {
    category: "Information Technology",
    title: "Microsoft 365 IT Systems Administrator",
    copy:
      "Presented on deterministic security control planes and the future of compliance infrastructure in regulated environments.",
    location: "Remote / Hybrid",
    type: "Full-Time"
  },
  {
    category: "Information Technology",
    title: "TBD",
    copy: "Lorem Ipsum",
    location: "Remote / Hybrid",
    type: "Full-Time"
  }
];

export function CareersPage() {
  useDocumentMeta({
    canonicalPath: "/careers",
    description:
      "Explore careers at Holocron Security and help build authoritative control-plane infrastructure for security and compliance.",
    title: "Careers | Holocron Security"
  });

  return (
    <>
      <section className="hero-banner hero-banner--careers">
        <div className="hero-banner-content hero-banner-content--center">
          <p className="hero-label">Careers</p>
          <h1 className="hero-title">Build the Authoritative Control Plane for Security &amp; Compliance</h1>
          <div className="hero-actions hero-actions--centered">
            <SmartLink className="button primary" href="#open-positions">
              View Open Positions
            </SmartLink>
            <SmartLink className="button secondary" href="#what-we-value">
              Explore Our Values
            </SmartLink>
          </div>
        </div>
      </section>

      <section className="surface-dark">
        <div className="section-shell split-layout">
          <div className="split-copy">
            <h2 className="section-title">Why Join Holocron</h2>
            <div className="stack-copy">
              <p>Holocron is not building another security tool.</p>
              <p>We are defining a new infrastructure layer for regulated digital environments.</p>
            </div>
            <p className="section-subtitle">You will work on:</p>
            <ul className="bullet-list">
              <li>Deterministic policy systems</li>
              <li>Replayable control-plane architecture</li>
              <li>Ledger-bound proof models</li>
              <li>Non-bypassable authorization paths</li>
            </ul>
          </div>

          <div className="media-card media-card--portrait media-card--orb">
            <img alt="Holocron product interface and workflow imagery" src="/assets/img/workflows-2.png" />
          </div>
        </div>
      </section>

      <section className="surface-light" id="open-positions">
        <div className="section-shell section-shell--narrow">
          <h2 className="section-title section-title--light">Open Positions</h2>
          <p className="section-copy section-copy--light">Find your next opportunity and make an impact.</p>
          <div className="filter-pill">All</div>

          <div className="jobs-list">
            {jobCards.map((job) => (
              <article key={job.title} className="job-card job-card--light">
                <div className="job-card-main">
                  <p className="job-category">{job.category}</p>
                  <h3>{job.title}</h3>
                  <p>{job.copy}</p>
                  <div className="job-meta">
                    <span>
                      <Icon className="meta-icon" name="location" />
                      {job.location}
                    </span>
                    <span>
                      <Icon className="meta-icon" name="clock" />
                      {job.type}
                    </span>
                  </div>
                </div>

                <div className="job-card-actions">
                  <SmartLink
                    className="button button-violet"
                    href={`mailto:info@holocronsecurity.com?subject=${encodeURIComponent(`Apply: ${job.title}`)}`}
                  >
                    Apply
                  </SmartLink>
                  <SmartLink className="button button-outline-violet" href="/contact">
                    View Details
                  </SmartLink>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="surface-gradient surface-gradient--values" id="what-we-value">
        <div className="section-shell">
          <h2 className="section-title section-title--center">What We Value</h2>
          <div className="card-grid value-grid">
            {valueCards.map((card) => (
              <article key={card.title} className="value-card">
                <div className="icon-badge">
                  <Icon name={card.icon} />
                </div>
                <h3>{card.title}</h3>
                <p>{card.copy}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="surface-dark cta-band">
        <div className="section-shell cta-center">
          <h2 className="section-title section-title--center">
            If you care about building systems that regulators, auditors, and executives rely on as definitive truth
            we want to hear from you.
          </h2>
          <div className="hero-actions hero-actions--centered">
            <SmartLink className="button primary" href="#open-positions">
              View Open Positions
            </SmartLink>
          </div>
        </div>
      </section>
    </>
  );
}
